



















import Vue from "vue";

export default Vue.extend({
  name: "CommentCodeBlock",
  props: {
    theme: {
      type: String,
      required: true,
    },
    codeArray: {
      type: Array,
      required: true,
    },
  },
});
